export default __webpack_public_path__ + "static/media/checked.b950b2ab.svg";